// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmploymentStatusDto
 */
export interface IEmploymentStatusDto {
    /**
     * 
     * @type {string}
     * @memberof IEmploymentStatusDto
     */
    status?: IEmploymentStatusDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IEmploymentStatusDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IEmploymentStatusDto
     */
    valid_to?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IEmploymentStatusDto
     */
    is_active?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IEmploymentStatusDtoStatusEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}


/**
 * Check if a given object implements the IEmploymentStatusDto interface.
 */
export function instanceOfIEmploymentStatusDto(value: object): value is IEmploymentStatusDto {
    return true;
}

export function IEmploymentStatusDtoFromJSON(json: any): IEmploymentStatusDto {
    return IEmploymentStatusDtoFromJSONTyped(json, false);
}

export function IEmploymentStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmploymentStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
    };
}

export function IEmploymentStatusDtoToJSON(json: any): IEmploymentStatusDto {
    return IEmploymentStatusDtoToJSONTyped(json, false);
}

export function IEmploymentStatusDtoToJSONTyped(value?: IEmploymentStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
        'is_active': value['is_active'],
    };
}

